<template>
  <div class="toggle">
    <label class="toggle__switch">
      <input
        v-model="checked"
        type="checkbox"
        :disabled="isDisabled"
        @click="result()"
      >
      <span class="toggle__switch__slider" />

    </label>
    <span
      v-if="label"
      class="toggle__label"
      :class="{'toggle__label--active': checked }"
    >
      {{ $t('active') }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'ToggleView',

  props: {
    label: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      checked: true
    };
  },

  methods: {
    result() {
      this.$emit('setResult', !this.checked);
      return true;
    }
  }
};
</script>

<style lang="scss" src="@/assets/components/toggle/toggle-view.scss"></style>



// WEBPACK FOOTER //
// toggle-view.vue